import { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Box,
  Alert,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBR from 'date-fns/locale/pt-BR';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { format, isBefore, isAfter, compareAsc, compareDesc } from 'date-fns';

function ListaAvisos() {
  const navigate = useNavigate();
  const [avisos, setAvisos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [dialogoConfirmacao, setDialogoConfirmacao] = useState({
    aberto: false,
    avisoId: null,
  });

  useEffect(() => {
    carregarAvisos();
  }, []);

  const carregarAvisos = async () => {
    try {
      const response = await axios.get('https://avisos.tibmacae.org.br/api.php');
      setAvisos(response.data);

      setErro('');
    } catch (erro) {
      console.error('Erro ao carregar avisos:', erro);
      const mensagemErro = erro.response?.data?.error ||
        erro.response?.data?.details?.join('\n') ||
        'Erro ao carregar avisos. Por favor, tente novamente.';
      setErro(mensagemErro);
    } finally {
      setCarregando(false);
    }
  };

  const handleExcluir = async (id) => {
    try {
      await axios.delete(`https://avisos.tibmacae.org.br/api.php?id=${id}`);
      setAvisos(avisos.filter(aviso => aviso.id !== id));
      setDialogoConfirmacao({ aberto: false, avisoId: null });
      setErro('');
    } catch (erro) {
      console.error('Erro ao excluir aviso:', erro);
      const mensagemErro = erro.response?.data?.error ||
        erro.response?.data?.details?.join('\n') ||
        'Erro ao excluir aviso. Por favor, tente novamente.';
      setErro(mensagemErro);
    }
  };

  const handleEditar = (id) => {
    navigate(`/avisos/editar/${id}`, { replace: true });
  };

  const handleNovo = () => {
    navigate('/avisos/novo', { replace: true });
  };

  const filtrarAvisos = () => {
    if (!dataInicio && !dataFim) return avisos;

    return avisos.filter(aviso => {
      const dataInicioAviso = new Date(aviso.data_inicio);
      const dataFimAviso = new Date(aviso.data_fim);

      if (dataInicio && dataFim) {
        return dataInicioAviso >= dataInicio && dataFimAviso <= dataFim;
      } else if (dataInicio) {
        return dataInicioAviso >= dataInicio;
      } else if (dataFim) {
        return dataFimAviso <= dataFim;
      }

      return true;
    });
  };

  const avisosFiltrados = filtrarAvisos();

  if (carregando) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  const color = (data_inicio, data_fim) => {

    console.log(format(new Date(), 'yyyy-MM-dd h:m:s'));
    console.log(data_fim);
    const hoje = format(new Date(), 'yyyy-MM-dd');
    const datafim = format(data_fim, 'yyyy-MM-dd');
    const datainicio = format(data_inicio, 'yyyy-MM-dd');
    
    if (compareAsc(hoje, datafim) == 0) {
      return '#eae354';
    }

    if (compareAsc(hoje, datainicio) >= 0 && compareDesc(hoje, datafim) > 0) {
      return '#a1edd2';
    }

  }

  // const color = (data_inicio, data_fim) => {

  //   console.log(format(new Date(), 'yyyy-MM-dd h:m:s'));
  //   console.log(data_fim);
  //   const hoje = format(new Date(), 'yyyy-MM-dd h:m:s');
  //   console.log(compareAsc(hoje, data_inicio));
  //   console.log(compareDesc(hoje, data_fim));
  //   if(compareAsc(hoje, data_inicio) > 0 && compareDesc(hoje, data_fim) > 0 ){        
  //       return '#a1edd2';
  //   }

  // }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1">
            Avisos
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNovo}
          >
            Novo Aviso
          </Button>
        </Box>

        {erro && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {erro}
          </Alert>
        )}

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <DatePicker
              label="Data Inicial"
              value={dataInicio}
              onChange={(newValue) => setDataInicio(newValue)}
              sx={{ flex: 1 }}
            />
            <DatePicker
              label="Data Final"
              value={dataFim}
              onChange={(newValue) => setDataFim(newValue)}
              sx={{ flex: 1 }}
            />
          </Box>
        </LocalizationProvider>

        <Box sx={{ mt: 1, display: 'flex' }}>
          <div
            style={{ backgroundColor: '#eae354', width: "4%" }}
          >
          </div>
          <h5 style={{ margin: '0 10px 0 10px', padding: 0 }}>Acontece hoje</h5>
          <div
            style={{ backgroundColor: '#a1edd2', width: "4%" }}
          >
          </div>
          <h5 style={{ margin: '0 10px 0 10px', padding: 0 }}>Vai acontecer</h5>
        </Box>

        {avisosFiltrados.length === 0 ? (
          <Alert severity="info">
            Nenhum aviso encontrado no período selecionado.
          </Alert>
        ) : (
          <List>
            {avisosFiltrados.map((aviso) => (
              <ListItem
                key={aviso.id}
                divider
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  backgroundColor: color(aviso.data_inicio, aviso.data_fim)


                }}
                style={{
                  borderBottom: 'inset',

                }}
              >
                <ListItemText
                  primary={aviso.titulo}
                  secondary={
                    <>
                      <Typography component="span" variant="body2" color="text.primary">
                        {aviso.descricao}
                      </Typography>
                      <br />
                      <Typography component="span" variant="body2" color="text.secondary">
                        Período: {format(new Date(aviso.data_inicio), 'dd/MM/yyyy')} - {format(new Date(aviso.data_fim), 'dd/MM/yyyy')}
                      </Typography>
                    </>
                  }
                />
                {aviso.arquivo && (
                  <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
                    <a
                      href={aviso.arquivo}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none' }}
                    >
                      <Button variant="outlined" size="small">
                        Ver Anexo
                      </Button>
                    </a>
                    <a
                      href={'/uploads/' + aviso.arquivo.split('/').pop()}
                      download={aviso.arquivo.split('/').pop()}
                      style={{ textDecoration: 'none' }}
                    >
                      <Button variant="outlined" size="small" color="secondary">
                        Download
                      </Button>
                    </a>
                  </Box>
                )}
                <ListItemSecondaryAction sx={{ right: 1 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }}>
                    <IconButton
                      edge="end"
                      aria-label="editar"
                      onClick={() => handleEditar(aviso.id)}
                      sx={{ mr: 0 }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      edge="end"
                      aria-label="excluir"
                      onClick={() => setDialogoConfirmacao({ aberto: true, avisoId: aviso.id })}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        )}
      </Paper>

      <Dialog
        open={dialogoConfirmacao.aberto}
        onClose={() => setDialogoConfirmacao({ aberto: false, avisoId: null })}
      >
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir este aviso?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDialogoConfirmacao({ aberto: false, avisoId: null })}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => handleExcluir(dialogoConfirmacao.avisoId)}
            color="error"
            variant="contained"
          >
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default ListaAvisos; 